/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        organization : [],
    },

    methods : {

    },

    getters : {

        getAllOrganization(state) {

            return state.organization;

        },

        getOrganizationById: (state) => (id) => {
            return state.organization.find(item => item.id === id)
        },


    },

    mutations: {

        setOrganization(state, organization) {
            state.organization = organization;
        },

        updateOrganization(state, data) {
            let index = state.organization.findIndex(item => item.id == data.id);
            if (index > -1) { // значит замена
                state.organization.splice(index, 1, data);
            } else {
                state.organization.push(data);
            }
        }
    },

    actions : {

        deleteOrg({rootState, rootGetters}, id) {
            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.delete('/organizations/'+id)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setOrganization', 'content' : response.data});     
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });

            });

        },

        updateCompanyName({dispatch, commit, rootState, rootGetters}, data) {
            
            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.post('/updateCompany', data)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setMyCompany', 'content' : response.data});     
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });

            });

        },

        getOrganization({dispatch, commit, rootState }) {

            return new Promise((resolve, reject) => {

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                    axios.get('/organizations')
                    .then(response => {
                        commit('setOrganization', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error)
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;                        
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка через некоторое время
                                dispatch('getOrganization');
                            }, t);
                        }
                        reject(error.response.status)
                    });
            });

        },
        
        addNewOrg({rootState, rootGetters}, data) {
            
            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                console.log(data);
                axios.post('/update', data)
                .then(response => {
                    // commit('updateOrganization', response.data);
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrganization', 'content' : response.data});     
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error)
                });

            });
        }

    }

}